<script setup lang="ts">
// icon
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export interface CiFanclubFilterProps {
  small?: boolean;
}
const props = withDefaults(defineProps<CiFanclubFilterProps>(), {
  small: false,
});

const emit = defineEmits<{
  change: [value: { filter: string; value: boolean }];
}>();

/********************
 * COMPOSITIONS      *
 ********************/
const route = useRoute();
const { $gettext } = useGettext();
const { openModal, closeModal } = useCiModal();

/********************
 * FUNCTIONS         *
 ********************/
function onFanclubFilter(value: boolean) {
  emit('change', { value, filter: 'fanclub' });
}

function openFanclubInfoModal() {
  const CiFanclubInfoModal = defineAsyncComponent({
    loader: () => import('@/components/fanclub/CiFanclubInfoModal.vue'),
  });

  openModal(
    {
      component: CiFanclubInfoModal,
      attrs: {
        name: 'CiFanclubInfoModal',
        onClose: () => {
          closeModal('CiFanclubInfoModal');
        },
      },
    },
    {
      clickToClose: true,
      contentTransition: 'translate-y-down',
      contentClass: 'max-w-[600px] w-full max-h-[800px] h-auto',
    },
  );
}
</script>

<template>
  <CiInfoPanel
    :condition="true"
    type="darkgreen"
    class="fanclub-info relative m-0 flex items-center !p-[6px]"
    :class="{ 'fanclub-info--responsive md:mb-6 md:ml-6 md:!py-3 md:px-4': !props.small }"
  >
    <div :class="[props.small ? 'block size-[50px]' : 'block size-[50px] md:hidden']">
      <img
        src="~/assets/svg/fanclub-logo-small.svg"
        alt="Fanclub logo"
        class="relative size-full"
        loading="lazy"
      />
    </div>
    <img
      src="~/assets/svg/fanclub-logo.svg"
      width="90"
      height="90"
      alt="Fanclub logo"
      class="absolute left-0 top-1/2 size-[90px] -translate-y-1/2 translate-x-[-25px]"
      loading="lazy"
      :class="[props.small ? 'hidden' : 'hidden  md:block']"
    />
    <div
      class="ml-[10px] flex grow items-center"
      :class="{ 'md:ml-[70px]': !props.small }"
    >
      <div class="flex grow flex-col">
        <div
          class="font-medium"
          :class="[props.small ? 'block' : 'block md:hidden']"
        >
          FANCLUB
        </div>
        <div
          class="font-medium"
          :class="[props.small ? 'hidden' : 'hidden md:block']"
        >
          camping.info FANCLUB
        </div>
        <div :class="[props.small ? '' : 'm-0 p-0 sm:flex sm:items-center']">
          <span :class="[props.small ? 'inline' : 'inline md:hidden']">{{ $gettext('campsites') }}</span>
          <span :class="[props.small ? 'hidden' : 'hidden md:inline']">{{
            $gettext('Show participating campsites')
          }}</span>

          <button
            class="button button--icon ml-2 translate-y-[3px] p-0"
            :class="{ 'sm:translate-y-0': !props.small }"
            type="button"
            aria-label="info"
            @click="openFanclubInfoModal"
          >
            <CiAwesomeIcon
              :icon="faInfoCircle"
              class="fill-white"
              ratio="0.7"
            />
          </button>
        </div>
      </div>
      <InputSwitch
        class="ml-auto"
        :value="!!route.query.fanclub"
        name="fanclub"
        @input="onFanclubFilter"
      />
    </div>
  </CiInfoPanel>
</template>

<style></style>
